/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { AvailabilityApiConfiguration as __Configuration } from '../availability-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ListQueryResultWorkShiftInfo } from '../models/list-query-result-work-shift-info';
import { CreateWorkShiftCommand } from '../models/create-work-shift-command';
import { UpdateWorkShiftCommand } from '../models/update-work-shift-command';
@Injectable({
  providedIn: 'root',
})
class WorkShiftService extends __BaseService {
  static readonly GetAllPath = '/api/availability/work-shifts';
  static readonly CreateWorkShiftPath = '/api/availability/work-shifts';
  static readonly DeleteWorkShiftPath = '/api/availability/work-shifts';
  static readonly GetUpdateWorkShiftPath = '/api/availability/work-shifts/{id}/update';
  static readonly UpdateWorkShiftPath = '/api/availability/work-shifts/{id}/update';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `WorkShiftService.GetAllParams` containing the following parameters:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * @return Success
   */
  GetAllResponse(params: WorkShiftService.GetAllParams): __Observable<__StrictHttpResponse<ListQueryResultWorkShiftInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (params.sortFields || []).forEach(val => {if (val != null) __params = __params.append('sortFields', val.toString())});
    (params.sortCriteria || []).forEach(val => {if (val != null) __params = __params.append('sortCriteria', val.toString())});
    if (params.pattern != null) __params = __params.set('pattern', params.pattern.toString());
    if (params.pageSize != null) __params = __params.set('pageSize', params.pageSize.toString());
    if (params.pageNumber != null) __params = __params.set('pageNumber', params.pageNumber.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/availability/work-shifts`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListQueryResultWorkShiftInfo>;
      })
    );
  }
  /**
   * @param params The `WorkShiftService.GetAllParams` containing the following parameters:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * @return Success
   */
  GetAll(params: WorkShiftService.GetAllParams): __Observable<ListQueryResultWorkShiftInfo> {
    return this.GetAllResponse(params).pipe(
      __map(_r => _r.body as ListQueryResultWorkShiftInfo)
    );
  }

  /**
   * @param command undefined
   */
  CreateWorkShiftResponse(command?: CreateWorkShiftCommand): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = command;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/availability/work-shifts`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param command undefined
   */
  CreateWorkShift(command?: CreateWorkShiftCommand): __Observable<null> {
    return this.CreateWorkShiftResponse(command).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   */
  DeleteWorkShiftResponse(id?: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/availability/work-shifts`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param id undefined
   */
  DeleteWorkShift(id?: string): __Observable<null> {
    return this.DeleteWorkShiftResponse(id).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   * @return Success
   */
  GetUpdateWorkShiftResponse(id: string): __Observable<__StrictHttpResponse<UpdateWorkShiftCommand>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/availability/work-shifts/${id}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UpdateWorkShiftCommand>;
      })
    );
  }
  /**
   * @param id undefined
   * @return Success
   */
  GetUpdateWorkShift(id: string): __Observable<UpdateWorkShiftCommand> {
    return this.GetUpdateWorkShiftResponse(id).pipe(
      __map(_r => _r.body as UpdateWorkShiftCommand)
    );
  }

  /**
   * @param params The `WorkShiftService.UpdateWorkShiftParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  UpdateWorkShiftResponse(params: WorkShiftService.UpdateWorkShiftParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.command;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/availability/work-shifts/${params.id}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `WorkShiftService.UpdateWorkShiftParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  UpdateWorkShift(params: WorkShiftService.UpdateWorkShiftParams): __Observable<null> {
    return this.UpdateWorkShiftResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module WorkShiftService {

  /**
   * Parameters for GetAll
   */
  export interface GetAllParams {
    sortFields?: Array<any>;
    sortCriteria?: Array<any>;
    pattern?: string;
    pageSize?: number;
    pageNumber?: number;
  }

  /**
   * Parameters for UpdateWorkShift
   */
  export interface UpdateWorkShiftParams {
    id: string;
    command?: UpdateWorkShiftCommand;
  }
}

export { WorkShiftService }
